export default "__VITE_ASSET__DHfc1pi3__"